import { Modal, ModalProps } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as CloseIcon } from "@/assets/images/close_icon.svg";
import SJButton from "../SJButton";
import "./index.scss";

const SJModal = ({
  open,
  title,
  onCancel,
  closable = true,
  children,
  onOk,
  okText,
  ...props
}: ModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      width={572}
      open={open}
      keyboard={false}
      closable={closable}
      title={title}
      centered
      closeIcon={<CloseIcon className="sj-modal-close-icon" />}
      onCancel={onCancel}
      footer={
        <div className="sj-modal-footer">
          <div className="sj-modal-footer-btns">
            <SJButton
              // className="sj-modal-footer-btns-item"
              onClick={onCancel as any}
            >
              {t("sensechat-21")}
              {/* 取消 */}
            </SJButton>
            <SJButton onClick={onOk as any}>{okText}</SJButton>
          </div>
        </div>
      }
      {...props}
      className={"sj-modal" + props.className ?? ""}
    >
      {/* <div className={"sj-modal-bg " + bgClass}>
        <img className="sj-modal-bg-logo" src={logoIcon}></img>
      </div> */}
      {children}
    </Modal>
  );
};

export default SJModal;
